import { render, staticRenderFns } from "./PorSectores.vue?vue&type=template&id=48d3ab88"
import script from "./PorSectores.vue?vue&type=script&lang=js"
export * from "./PorSectores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports